var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1H1v6h6V1zM15 1H9v6h6V1zM23 1h-6v6h6V1zM7 9H1v14h6V9zM23 9H9v6h14V9zM15 17H9v6h6v-6zM23 17h-6v6h6v-6z"
  })));
}

export default __webpack_public_path__ + "fe721a18de3e53537a833700f5b05cf9.svg";
export { SvgDashboard as ReactComponent };